<template>
	<div class="header_nav_box">
		<!-- 上半部分 -->
		<header-top v-show="visibleHeader2"></header-top>
		<!-- 下半部分 -->
		<header-bottom
			v-show="visibleHeader && this.$route.path.indexOf('center')<0 && this.$route.path.indexOf('service')<0">
		</header-bottom>
	</div>
</template>

<script>
	import {
		mapActions
	} from 'vuex'

	export default {
		data() {
			return {
				visibleHeader: true,
				visibleHeader2: false
			}
		},
		components: {
			headerTop: () => import('@/components/headerTop'),
			headerBottom: () => import('@/components/headerBottom')
		},
		mounted() {
			setTimeout(() => {
				this.visibleHeader2 = true
			}, 1000)
		},
		methods: {
			...mapActions([
				"getMiddleNav"
			]),
			// 滚动事件
			handleScroll() {
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				if (scrollTop >= 50) {
					this.visibleHeader = false;
				} else {
					this.visibleHeader = true;
				}
			}
		},
		created() {
			window.addEventListener('scroll', this.handleScroll);
			// 参数获取
			this.getMiddleNav();
		},
		watch: {
			$route() {
				this.handleScroll();
			}
		},
	}
</script>

<style scoped>
	/* 组件盒子 */
	.header_nav_box {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		background: #fff;
		border-bottom: 1px solid #e7e7e7;
		z-index: 1200;
	}
</style>
